import React from "react";
import { Link } from "react-router-dom";
import { absUrl } from "../services/api";
import { CATEGORY_MAP } from "../lib/categories";
import "./ArticleCard.css";

export default function ArticleCard({ article, variant = "default" }) {
  if (!article) return null;
  const categoryName = CATEGORY_MAP[article.category] || article.category;
  const date = article.published_at
    ? new Date(article.published_at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
    : "";

  return (
    <Link
      to={`/news/${article.slug}`}
      className={`article-card article-card--${variant}`}
      data-testid={`article-card-${article.slug}`}
    >
      <div className="article-card__image-wrap">
        {article.featured_image ? (
          <img src={absUrl(article.featured_image)} alt={article.title} className="article-card__image" loading="lazy" />
        ) : (
          <div className="article-card__image-placeholder" />
        )}
        <span className="article-card__category">{categoryName}</span>
      </div>
      <div className="article-card__body">
        <h3 className="article-card__title">{article.title}</h3>
        {article.excerpt && <p className="article-card__excerpt">{article.excerpt}</p>}
        <div className="article-card__meta">
          <span>{article.author}</span>
          {date && <span className="article-card__dot">•</span>}
          {date && <span>{date}</span>}
        </div>
      </div>
    </Link>
  );
}
